// @flow
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import type { FieldProps, FormProps } from "redux-form";
import { Field } from "redux-form";
import { Checkbox, Divider, Form, Grid, Header } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { ChangeServiceAuthorizationRoute } from "../../ChangeServices/Routes";
import { useChangeServiceHook } from "./ChangeServiceHook";
import { uniqueCounterNumber } from "modules/ChangeService/ChangeServices/submodules/Old_Edit/misc/Validators.js";

export const FooterNote = () => {
  return (
    <div>
      <Trans i18nKey="changeService:wizard.payment.copyRightMessage">
        Text
        <a href={ChangeServiceAuthorizationRoute} target="_blank" rel="noopener noreferrer" className="link">
          Link
        </a>
        Text
      </Trans>
    </div>
  );
};

const TextAreaField = (props: FieldProps) => {
  const { input, meta } = props;
  return (
    <Form.Field error={!!meta.error && meta.touched}>
      <Form.TextArea {...input} error={!!meta.error && meta.touched && meta.error} />
    </Form.Field>
  );
};

export function CommentBox({ fieldName, validation }: { fieldName: string, validation: Function }) {
  const { t } = useTranslation("common");
  return (
    <Form.Field>
      <div className="provider-missing-box">
        <span className="provider-missing-box-text">{t("common:commentLater")}</span>
        <Field name={fieldName} component={TextAreaField} validate={[validation]} />
      </div>
    </Form.Field>
  );
}

export const CompanyCheckBox = ({
  checked,
  setChecked,
  isCompany,
}: {
  checked: boolean,
  setChecked?: (boolean) => void,
  isCompany: boolean,
}) => {
  const { t } = useTranslation("changeService");
  if (!isCompany) {
    return null;
  }
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column only={"tablet computer"} width={2} />
        <Grid.Column width={1} verticalAlign={"middle"}>
          <Checkbox checked={checked} onClick={() => setChecked && setChecked(!checked)} />
        </Grid.Column>
        <Grid.Column tablet={11} computer={11} mobile={14}>
          <p>{t("companyDisclaimer")}</p>
        </Grid.Column>
        <Grid.Column width={2} only={"tablet computer"} />
      </Grid.Row>
    </Grid>
  );
};

export const BenefitsArrowsAndCircles = ({
  invertedCategoryName,
  t,
}: {
  invertedCategoryName: string,
  t: typeof TFunction,
}) => {
  return (
    <Grid verticalAlign={"middle"} textAlign={"center"}>
      <Divider hidden />
      <Grid.Row>
        <Header as={"h3"}>
          {t("mobile.confirmation.changeServiceProcess", { categoryName: invertedCategoryName })}
        </Header>
      </Grid.Row>
      <Grid.Row>
        <ol className={"list"}>
          {t("wizard.confirmationPage.benefitsList", { returnObjects: true }).map((benefit, i) => {
            return (
              <li key={i}>
                <span>{benefit}</span>
                {i === 0 && (
                  <>
                    <br />
                    <div className={"gray-section-in-list"}>{t("wizard.confirmationPage.benefitsExtraSegment")}</div>
                  </>
                )}
              </li>
            );
          })}
        </ol>
      </Grid.Row>
    </Grid>
  );
};

export const NotUniqueCounterNumber = ({
  categorySlug,
  change,
}: {
  categorySlug: string,
  change: $PropertyType<FormProps, "change">,
}) => {
  const { category, currentValues } = useChangeServiceHook({
    categorySlug,
    change,
  });
  const changeServices = useSelector(({ changeServices }) => changeServices.changeServices);
  return (
    uniqueCounterNumber(
      changeServices[category.id],
      currentValues.counterNumber || currentValues.futureCounterNumber,
      currentValues
    ) || null
  );
};
